import { getZeroMonetaryValue } from '../../../../utils/monetary-value-utils';
import { getOrderSubscription } from './get-order-subscription';
export const getOrderSubscriptionPrice = () => { var _a; return ((_a = getOrderSubscription()) === null || _a === void 0 ? void 0 : _a.price) || getZeroMonetaryValue(); };
//# sourceMappingURL=get-order-subscription-price.js.map